import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'
import type {IconAttrs} from '@bitstillery/common/components/ui/icon/icon'

interface SpinnerAttrs {
    className?: string
    size?: IconAttrs['size']
    type?: IconAttrs['type']
}

export class Spinner extends MithrilComponent<SpinnerAttrs> {
    view(vn: m.Vnode<SpinnerAttrs>) {
        return (
            <svg
                className={classes(
                    'c-spinner',
                    'c-icon',
                    vn.attrs.className,
                    `type-${vn.attrs.type ? vn.attrs.type : 'default'}`,
                    `icon-${vn.attrs.size ?? 'd'}`,
                )}
                height='24'
                viewBox='0 0 24 24'
                width='24'
            >
                <circle class='path' cx='12' cy='12' r='8' fill='none' stroke-width='4'></circle>
            </svg>
        )
    }
}
